//@flow
import './index.css'
import './rollbar'

import App from './App'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import { MemoryRouter as Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import registerServiceWorker from './registerServiceWorker'
import store from './state/store'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-106777666-2')
const historyListener = location => {
    ReactGA.set({ page: location.pathname + location.search })
    ReactGA.pageview(location.pathname + location.search)
}
historyListener(window.location)
const history = createBrowserHistory()
history.listen(historyListener)

const rootEl = document.getElementById('root')

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>,
    rootEl,
)
registerServiceWorker()

if (
    module.hot &&
    typeof module.hot === 'object' &&
    typeof module.hot.accept === 'function'
) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default
        ReactDOM.render(
            <Provider store={store}>
                <Router history={history}>
                    <NextApp />
                </Router>
            </Provider>,
            rootEl,
        )
    })
}



// WEBPACK FOOTER //
// ./src/index.js